import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=4325998d&scoped=true&"
import script from "./ServiceCenter.vue?vue&type=script&lang=js&"
export * from "./ServiceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325998d",
  null
  
)

export default component.exports